import { baseApi } from '@/lib/store/api/baseQuery'
import { chosenPharmacyCleared } from '@/lib/store/chosenPharmacySlice'
import { store } from '@/lib/store/store'

/** Drops authenticated RTK Query cache entries (including file download previews) and other per-patient state on logout. */
export function clearAuthenticatedApiCache() {
    store.dispatch(baseApi.util.resetApiState())
    store.dispatch(chosenPharmacyCleared())
}
